class MultimediaVideos {
	constructor(sel = '.bp-multimedia') {
		this.components = document.querySelectorAll(sel);
		if (!this.components.length) return;
		this.init();
		this.mobile = this.isMobile();

	}
	isMobile = () => window.innerWidth < 961;
	swapSrc = (multimedia) => {
		const video = multimedia.querySelector('video');
		const src = this.isMobile()
			? video.querySelector('source[media*="max-width"]').src
			: video.querySelector('source[media*="min-width"]').src;

		video.src = src;

		if (video.autoplay) {
			video.muted = true; // necesario para autoplay
			video.playsInline = true;
			video.autoplay = true;

			video.load(); // fuerza a recargar la metadata
			video.play().catch(err => {
				console.log('Safari bloqueó el autoplay:', err);
			});

		}
	}

	onResizePerFrame = (callback) => {
		let ticking = false;

		const handleResize = () => {
			if (!ticking) {
				ticking = true;
				requestAnimationFrame(() => {
					callback(); // tu lógica de resize
					ticking = false;
				});
			}
		};

		window.addEventListener('resize', handleResize);
	}

	updateSrc = () => {
		this.components.forEach(comp => {
			if (comp.querySelector('img')) return;
			this.swapSrc(comp)
		})
	}
	init = () => {
		this.onResizePerFrame(() => {
			if (this.mobile == this.isMobile()) return;
			this.updateSrc();
			this.mobile = this.isMobile();
		})
		if (this.isMobile()) this.updateSrc();
	}
}

new MultimediaVideos();
